import axios from "axios";

export const deleteBookingAttachment =  async (id: string): Promise<void> => {
    const response = await axios.delete(`/booking/attachment/${id}`);
    return response.data;
};

export default deleteBookingAttachment;